/**
 * 仅用于 H5「我的信息」中点击眼睛查看本次登录所填密码明文。
 * 服务端仅存哈希，无法回传；故仅在登录成功时写入 sessionStorage，关闭标签页或退出后失效。
 */
const KEY = 'yc_h5_session_plain_password';

export function setSessionPlainPassword(password) {
  if (password != null && password !== '') {
    try {
      sessionStorage.setItem(KEY, String(password));
    } catch {
      /* ignore quota / private mode */
    }
  }
}

export function clearSessionPlainPassword() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function getSessionPlainPassword() {
  try {
    return sessionStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
}
